<template>
  <div
    v-if="visible"
    class="flow-branch-menu"
    :style="{ top: `${position.y}px`, left: `${position.x}px` }"
    @click.stop
    @pointerdown.stop
  >
    <button
      class="flow-branch-menu__item"
      @click="$emit('action', 'add')"
    >
      <i class="fa fa-plus" />
      <span>{{ t('flows.branchMenu.add') }}</span>
    </button>
    <button
      v-if="showMerge"
      class="flow-branch-menu__item"
      @click="$emit('action', 'merge')"
    >
      <i class="fa fa-code-merge" />
      <span>{{ t('flows.branchMenu.merge') }}</span>
    </button>
    <button
      v-if="showClosure"
      class="flow-branch-menu__item"
      @click="$emit('action', 'closure')"
    >
      <i class="fa fa-compress-arrows-alt" />
      <span>{{ t('flows.branchMenu.closure') }}</span>
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { useI18n } from 'vue-i18n';
import type { BranchMenuAction } from '@/types/flow-types';

export default defineComponent({
  name: 'FlowBranchMenu',

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    position: {
      type: Object as PropType<{ x: number; y: number }>,
      default: () => ({ x: 0, y: 0 }),
    },
    showMerge: {
      type: Boolean,
      default: true,
    },
    showClosure: {
      type: Boolean,
      default: true,
    },
  },

  emits: ['action'],

  setup() {
    const { t } = useI18n();

    return {
      t,
    };
  },
});
</script>

<style lang="scss" scoped>
.flow-branch-menu {
  position: absolute;
  z-index: 1000;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  padding: 4px;
  min-width: 200px;
  transform: translate(-50%, 8px);
  white-space: nowrap;

  &__item {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    padding: 10px 14px;
    border: none;
    background: transparent;
    cursor: pointer;
    font-size: 14px;
    color: #374151;
    border-radius: 6px;
    transition: background-color 0.15s ease;
    text-align: left;
    white-space: nowrap;

    &:hover {
      background-color: #f3f4f6;
    }

    i {
      width: 16px;
      flex-shrink: 0;
      text-align: center;
      color: #6b7280;
    }

    span {
      flex: 1;
    }
  }
}
</style>
